import React from "react";
import { Box, Skeleton } from "@mui/material";

export default function GridLoadingState() {
  return (
    <Box data-testid="grid-loading-state" sx={{ borderRadius: 2, border: 1, borderColor: "divider", overflow: "hidden" }}>
      <Box sx={{ p: 1.5, display: "flex", justifyContent: "space-between", borderBottom: 1, borderColor: "divider" }}>
        <Skeleton variant="text" width={180} height={24} />
        <Skeleton variant="rounded" width={90} height={32} />
      </Box>
      <Box sx={{ p: 1, display: "flex", gap: 1, borderBottom: 1, borderColor: "divider" }}>
        {[60, 180, 220, 180, 160, 180].map((width, index) => (
          <Skeleton key={index} variant="rounded" width={width} height={22} />
        ))}
      </Box>
      <Box sx={{ p: 1, display: "flex", flexDirection: "column", gap: 1 }}>
        {Array.from({ length: 25 }).map((_, index) => (
          <Skeleton key={index} variant="rounded" height={28} />
        ))}
      </Box>
    </Box>
  );
}
